import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDynamicDataService } from '../efaact.dynamic-data-service';
import { DashboardSettings } from './dashboard-settings.model';


export const entityName = 'DashboardSettings';

@Injectable()
export class DashboardSettingsDataService extends EfaactDynamicDataService<DashboardSettings> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(
            http,
            httpUrlGenerator,
            entityName,
            log,
            config,
            store
        );
    }

    mapItems(item: DashboardSettings): DashboardSettings {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.DashboardItemID
        };
    }
}
